/**
 * Utility functions for parsing and handling API errors
 */

export interface IApiErrorResult {
  friendlyMessage: string;
  technicalDetails: string;
}

/**
 * Parses an API error into user-friendly and technical messages
 * @param err - The error object (Error, string, or any)
 * @param contextMessage - Optional context-specific message (e.g., "Unable to save sync schedule changes")
 * @returns Object with friendlyMessage and technicalDetails
 */
export const parseApiError = (err: any, contextMessage?: string): IApiErrorResult => {
  const technicalDetails = err instanceof Error ? err.message : String(err);
  let friendlyMessage = contextMessage || "Unable to complete the operation.";

  // Check for common HTTP error patterns
  if (technicalDetails.includes('401') || technicalDetails.includes('403') || technicalDetails.includes('Unauthorized')) {
    friendlyMessage = "Permission denied. You may not have access to perform this action.";
  } else if (technicalDetails.includes('Network') || technicalDetails.includes('timeout') || technicalDetails.includes('fetch')) {
    friendlyMessage = "Network connection issue. Please check your connection and try again.";
  } else if (technicalDetails.includes('500') || technicalDetails.includes('503') || technicalDetails.includes('Server Error')) {
    friendlyMessage = "Server error. The backend service may be experiencing issues. Please try again in a few moments.";
  } else if (technicalDetails.includes('404')) {
    friendlyMessage = "Resource not found. The requested item may have been deleted or moved.";
  } else if (technicalDetails.includes('400') || technicalDetails.includes('Bad Request')) {
    friendlyMessage = "Invalid data. Please verify your input and try again.";
  } else if (technicalDetails.includes('409') || technicalDetails.includes('Conflict')) {
    friendlyMessage = "Conflict detected. The resource may have been modified by another user.";
  }

  return { friendlyMessage, technicalDetails };
};
